module.exports = __webpack_public_path__ + "static/11-2bb98f8b24a111b23ca5a8c31faa7a9e.png";